import { defaultStatusColors } from "../pages/protected/leadsTracking/utils";
import { useLanguage } from "../stores/LanguageStore";
import { useLeadsStore } from "../stores/LeadsStore";
import { mainAxios as axios } from "./axios";
//#region Pagination
export const getFirstPagePrm = async ({ per_page, sort, filter }) => {
  return axios.get(`/prm/contacts`, {
    params: {
      options: JSON.stringify({
        per_page: per_page,
        filter: filter,
        sort: sort,
      }),
    },
  });
};

export const getFirstPagePrmUser = async ({ id, per_page, sort, filter }) => {
  return axios.get(`/prm/contacts/user/${id}`, {
    params: {
      options: JSON.stringify({
        per_page: per_page,
        filter: filter,
        sort: sort,
      }),
    },
  });
};

export const getFirstPagePrmShared = async ({
  per_page,
  sort,
  filter,
  conditions,
}) => {
  return axios.get(`/prm/contacts/shared`, {
    params: {
      options: JSON.stringify({
        per_page: per_page,
        filter: filter,
        sort: sort,
        conditions: conditions,
      }),
    },
  });
};

export const requestNextPage = async (next_url) => {
  return axios.get(next_url);
};
//#endregion

//#region Sharing
export const getOtherPrms = async () => {
  const res = await axios.get(`/prm/list`);
  if (res) {
    useLeadsStore.getState().setPrms(res.data.prm);
  }

  return res;
};

export const getSharings = async () => {
  const res = await axios.get(`/prm/sharings`);
  if (res) {
    useLeadsStore.getState().setSharings(res.data.sharings);
  }

  return res;
};

export const createSharing = async ({
  name,
  sharing_type_to,
  read_permission,
  write_permission,
  delete_permission,
  ids_list,
  filter,
  contact_ids,
}) => {
  return axios.post(`/prm/sharings`, {
    sharing: {
      name,
      sharing_type_to,
      read_permission,
      write_permission,
      delete_permission,
      ids_list,
      filter,
      contact_ids,
    },
  });
};

export const editSharing = async ({
  id,
  name,
  sharing_type_to,
  read_permission,
  write_permission,
  delete_permission,
  ids_list,
  filter,
  contact_ids,
}) => {
  return axios.put(`/prm/sharings/${id}`, {
    sharing: {
      name,
      sharing_type_to,
      read_permission,
      write_permission,
      delete_permission,
      ids_list,
      filter,
      contact_ids,
    },
  });
};
export const deleteSharing = async ({ id }) => {
  return axios.delete(`/prm/sharings/${id}`);
};
//#endregion

//#region Status
export const getStatusSystem = async () => {
  let r = await axios.get(`/prm/status`);
  let lang = useLanguage.getState().language;

  if (r.data) {
    let map = {
      opener: lang.components.status_selector.statuses.opener,
      clicker: lang.components.status_selector.statuses.clicker,
      answerer: lang.components.status_selector.statuses.answerer,
      to_call: lang.components.status_selector.statuses.to_call,
      out_of_office: lang.components.status_selector.statuses.out_of_office,
    };

    useLeadsStore.getState().setSystemStatuses(
      r.data.status.map((x) => ({
        ...x,
        name: map[x.status],
        id: x.status,
        color: x?.color || defaultStatusColors[x.status] || null,
      })),
    );
  }
  return r;
};
export const getStatusCustom = async () => {
  let r = await axios.get(`/prm/status/custom`);

  if (r.data) {
    useLeadsStore.getState().setCustomStatuses(
      r.data.status.map((x) => ({
        ...x,
        color: x?.color || defaultStatusColors[x?.type_default_status] || null,
      })),
    );
  }
  return r;
};
export const createStatus = async ({ name }) => {
  return axios.post(`/prm/status/custom`, { name });
};
export const editStatus = async ({
  id,
  name,
  visible,
  color,
  sorting,
  isSystem,
}) => {
  return axios.put(`/prm/status/${isSystem ? "" : "custom/"}${id}`, {
    name,
    visible,
    color,
    sorting,
  });
};
export const deleteStatusCustom = async ({ id }) => {
  return axios.delete(`/prm/status/custom/${id}`);
};
//#endregion

export const getColumnsWatchlist = async () => {
  return axios.get(`/prm/notifications/column-entry`);
};
export const updateColumnsWatchlist = async ({ watched_columns }) => {
  return axios.put(`/prm/notifications/column-entry`, { watched_columns });
};

//#region Calls
export const createReminder = async ({
  prospect_id,
  name,
  call_date,
  type,
}) => {
  return axios.post(`/prm/contact/${prospect_id}/call`, {
    name,
    call_date,
    type,
  });
};
export const deleteReminder = async ({ parent_id, id }) => {
  return axios.delete(`/prm/contact/${parent_id}/call/${id}`);
};
//#endregion

//#region Prospect
export const createProspect = async ({ properties, status, custom_status }) => {
  return axios.post(`/prm/contacts`, { properties, status, custom_status });
};
export const createProspectUser = async ({
  user_id,
  properties,
  status,
  custom_status,
}) => {
  return axios.post(`/prm/contacts/user/${parseInt(user_id)}`, {
    properties,
    status,
    custom_status,
  });
};
export const findProspect = async (id, set_new_reply_read) => {
  return axios.get(`/prm/contact/${id}`, {
    params: { set_new_reply_read: set_new_reply_read || undefined },
  });
};
export const updateProspect = async ({
  id,
  properties,
  status,
  custom_status,
  is_positive,
  score,
  amount,
  probability,
  closing_date,
  person_in_charge,
  tags_ids,
  new_reply,
  new_first_reply,
}) => {
  return axios.put(`/prm/contact/${id}`, {
    properties,
    status,
    custom_status,
    is_positive,
    score,
    amount,
    probability,
    closing_date,
    person_in_charge,
    tags_ids,
    new_reply,
    new_first_reply,
  });
};
export const updateProspectsStatus = async ({
  user_id,
  contacts_selection,
  status,
  custom_status,
}) => {
  return axios.put(`/prm/contacts/status`, {
    user_id,
    contacts_selection,
    status,
    custom_status,
  });
};

export const copyPrmToList = async ({
  contact_list_id,
  user_id,
  contacts_selection,
}) => {
  return axios.post(`/prm/contacts/contact-list/${contact_list_id}/add`, {
    user_id,
    contacts_selection,
  });
};
export const copyPrmToBlacklist = async ({
  blacklist_id,
  user_id,
  contacts_selection,
  datafield_ids,
}) => {
  return axios.post(
    `/prm/contacts/user/${user_id}/copy/blacklist/${blacklist_id}`,
    {
      user_id,
      contacts_selection,
      datafield_ids,
    },
  );
};

export const deleteProspects = async ({
  filter,
  contact_ids,
  excluded_contact_ids,
}) => {
  return axios.delete(`/prm/contacts/`, {
    data: {
      filter,
      contact_ids,
      excluded_contact_ids,
    },
  });
};
export const deleteProspectsUser = async ({
  user_id,
  filter,
  contact_ids,
  excluded_contact_ids,
}) => {
  return axios.delete(`/prm/contacts/user/${user_id}`, {
    data: {
      filter,
      contact_ids,
      excluded_contact_ids,
    },
  });
};
export const excludeProspectFromProgrammation = async ({
  contact_id,
  programmation_id,
}) => {
  return axios.post(
    `/prm/contact/${contact_id}/exclude/programmation/${programmation_id}`,
  );
};
export const excludeProspectFromWorkflow = async ({
  contact_id,
  workflow_id,
}) => {
  return axios.post(`/prm/contact/${contact_id}/exclude/${workflow_id}`);
};
export const progressProspectToStep = async ({
  contact_id,
  programmation_id,
  step_id,
}) => {
  return axios.post(
    `/prm/contact/${contact_id}/programmation/${programmation_id}/step/${step_id}`,
  );
};
export const markReply = async ({
  contact_id,
  history_type_reply,
  reply_id,
  is_positive,
}) => {
  return axios.put(
    `/prm/contact/${contact_id}/reply/${history_type_reply}/${reply_id}`,
    { is_positive },
  );
};

export const enrichProspectPhoneNumber = async ({ contact_id }) => {
  return axios.post(`/prm/contact/${contact_id}/enrich/phone/mobile`);
};

//#endregion

//#region Notes
export const createNote = async ({ prospect_id, note }) => {
  return axios.post(`/prm/contact/${prospect_id}/note`, { note });
};
export const uploadNoteAttachments = async ({
  prospect_id,
  note_id,
  formData,
}) => {
  return axios.post(
    `/prm/contact/${prospect_id}/note/${note_id}/attachment`,
    formData,
    {
      headers: {
        accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const editNote = async ({ prospect_id, note_id, note }) => {
  return axios.put(`/prm/contact/${prospect_id}/note/${note_id}`, { note });
};
export const deleteNote = async ({ prospect_id, note_id }) => {
  return axios.delete(`/prm/contact/${prospect_id}/note/${note_id}`);
};
export const deleteNoteAttachment = async ({
  prospect_id,
  note_id,
  attachment_id,
}) => {
  return axios.delete(
    `/prm/contact/${prospect_id}/note/${note_id}/attachment/${attachment_id}`,
  );
};
//#endregion

//#region Export
export const exportPrm = async ({
  file_type,
  filter,
  contact_ids,
  excluded_contact_ids,
  name,
}) => {
  let response = await axios.post(
    `/prm/contacts/export/${file_type}`,
    {
      filter,
      contact_ids,
      excluded_contact_ids,
    },
    {
      responseType: "blob",
    },
  );
  if (response) {
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name || `PRM_export`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  return response;
};

export const exportUserPrm = async ({
  user_id,
  file_type,
  filter,
  contact_ids,
  excluded_contact_ids,
  name,
}) => {
  let response = await axios.post(
    `/prm/contacts/user/${user_id}/export/${file_type}`,
    {
      filter,
      contact_ids,
      excluded_contact_ids,
    },
    {
      responseType: "blob",
    },
  );
  if (response) {
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name || `PRM_export`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  return response;
};

export const updateNewReplies = async ({
  user_id,
  filter,
  contact_ids,
  excluded_contact_ids,
  new_reply,
}) => {
  return axios.put(`/prm/contacts/new_reply`, {
    user_id,
    new_reply,
    contacts_selection: {
      filter,
      contact_ids,
      excluded_contact_ids,
    },
  });
};

export const addTagsToProspects = async ({
  user_id,
  filter,
  contact_ids,
  excluded_contact_ids,
  tag_ids,
}) => {
  return axios.post(`/prm/contacts/user/${user_id}/tags`, {
    tag_ids,
    filter,
    contact_ids,
    excluded_contact_ids,
  });
};

export const deleteTagsToProspects = async ({
  user_id,
  filter,
  contact_ids,
  excluded_contact_ids,
  tag_ids,
}) => {
  return axios.delete(`/prm/contacts/user/${user_id}/tags`, {
    data: {
      tag_ids,
      filter,
      contact_ids,
      excluded_contact_ids,
    },
  });
};

export const prmAddToList = async ({ contact_list_id, contact_ids }) => {
  return axios.post(`/prm/contacts/contact-list/${contact_list_id}/add`, {
    contact_ids,
  });
};

export const downloadEML = async ({ reply_id, id, isBlob = true }) => {
  const endpoint = id
    ? `/workflows/sent/email/${id}/download/eml`
    : `/workflows/reply/email/${reply_id}/download/eml`;
  return axios.get(endpoint, {
    responseType: isBlob ? "blob" : "text",
  });
};

//#endregion

//#region Nuturing
export const getNurturings = async () => {
  let res = await axios.get(`/prm/nurturings`);
  // if (res) {
  //   localStorage.setItem("custom_status", JSON.stringify(res.data.status))
  // }
  return res;
};
export const createNurturing = async ({ name, filter, contact_list_ids }) => {
  return axios.post(`/prm/nurturing`, { name, filter, contact_list_ids });
};
export const editNurturing = async ({ id, name, filter, contact_list_ids }) => {
  return axios.put(`/prm/nurturing/${id}`, { name, filter, contact_list_ids });
};
export const deleteNurturing = async ({ id }) => {
  return axios.delete(`/prm/nurturing/${id}`);
};
//#endregion

export const excludeFromProgrammation = async ({
  contact_id,
  programmation_id,
}) => {
  return axios.post(
    `/prm/contact/${contact_id}/exclude/programmation/${programmation_id}`,
  );
};

//#region Captcha
export const getCaptchas = async () => {
  return axios.get(`/integrations/email/protections`);
};
export const handleCaptcha = async (protection_id) => {
  return axios.put(`/integrations/email/protection/${protection_id}`, {
    handled: true,
  });
};
//#endregion

//# Enrich
export const getPrmJobs = async (userId) => {
  return axios.get(`/jobs/prm/${userId}`);
};
export const enrichPhonePrm = async ({
  user_id,
  enrich_external_api = "kaspr",
  external_api_key_id,
  filter,
  contact_ids,
  excluded_contact_ids,
}) => {
  if (user_id) {
    return axios.post(
      `/prm/contacts/user/${user_id}/enrich/external/${enrich_external_api}/${external_api_key_id}`,
      { filter, contact_ids, excluded_contact_ids },
    );
  }
  return axios.post(
    `/prm/contacts/enrich/external/${enrich_external_api}/${external_api_key_id}`,
    { filter, contact_ids, excluded_contact_ids },
  );
};
//#endregion
